import DataMixin from "./DataMixin";

export default {
    install(Vue, options) {
        Vue.mixin(DataMixin);
    }
}